import React from 'react';
import { Link } from 'react-router-dom';
import './Leadership.css';
import { leadership, principles, offices } from '../data/site';

const Leadership = () => {
  return (
    <div className="leadership-page page-shell">
      <section className="ld-hero section-dark">
        <span className="aurora-orb hero-orb-a" />
        <span className="aurora-orb hero-orb-b" />
        <div className="site-container-wide">
          <span className="section-eyebrow">Leadership</span>
          <h1>
            Senior practitioners. <span className="gradient-text serif-accent">Active operators.</span>
          </h1>
          <p>
            Dalytix is led by people who still ship. Our partners run delivery, our principals carry
            pagers, and our researchers publish work the rest of the team uses on Monday.
          </p>
        </div>
      </section>

      <section className="section ld-grid-section">
        <div className="site-container-wide">
          <div className="ld-grid">
            {leadership.map((leader) => (
              <article className="ld-card professional-card" key={leader.name}>
                <img src={leader.avatar} alt={`${leader.name}, ${leader.role}`} />
                <h3>{leader.name}</h3>
                <span className="ld-role">{leader.role}</span>
                <p className="ld-short">{leader.short}</p>
                <p className="ld-bio">{leader.bio}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section ld-principles section-dark">
        <div className="site-container-wide">
          <span className="section-eyebrow">How we lead</span>
          <h2 className="section-title">The operating principles our leaders hire and ship by.</h2>
          <div className="ld-principles-grid">
            {principles.map((p) => (
              <article className="glass-card ld-principle" key={p.title}>
                <h3>{p.title}</h3>
                <p>{p.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section ld-offices">
        <div className="site-container-wide">
          <span className="section-eyebrow">Where we work</span>
          <h2 className="section-title">Three delivery hubs. One team.</h2>
          <div className="ld-offices-grid">
            {offices.map((o) => (
              <article className="ld-office professional-card" key={o.city}>
                <img src={o.image} alt={o.city} />
                <div>
                  <strong>{o.city}, {o.country}</strong>
                  <span>{o.region}</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="ld-cta">
        <div className="site-container-wide professional-card">
          <h2>Want to work with senior practitioners?</h2>
          <p>Whether you are hiring us or joining us — the door is open.</p>
          <div className="hero-actions">
            <Link to="/contact" className="btn-primary-large">Contact Dalytix</Link>
            <Link to="/careers" className="btn-outline btn-arrow">See open roles</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Leadership;
